var Operator = window.Operator || {};
Operator.blockEditors = Operator.blockEditors || {};

$.extend(Operator.blockEditors, {
    WritePropertyBrickModel: function (opts) {
        var editor = opts.editor
            , form = editor.find('form')
            , valueIsPropertyPathSelector = form.find('[name$="ValueIsPropertyPath"]')
            , typeSelector = form.find('[name$="Type"]');
        
        //Type is ignored by our brick implementation when value is used as path
        var toggleTypeAvailability = function(){
            typeSelector.attr('disabled', valueIsPropertyPathSelector.is(':checked'));
        };

        toggleTypeAvailability();

        valueIsPropertyPathSelector.on('change', toggleTypeAvailability);
    }
});